































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ExternalLink extends Vue {
  @Prop()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config!: any;
}
